import React, { useState } from "react";
import { Input } from "antd";

export const InputField = ({
  label,
  name,
  value,
  onChange,
  type,
  placeholder,
  addonAfter,
  icon,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const wrapperStyle = {
    position: "relative",
    width: "100%",
  };

  const inputStyle = {
    border: "none",
    outline: "none",
    boxShadow: "none",
    paddingRight: icon ? "30px" : "10px",
    width: "100%",
  };

  // Handle focus and blur events
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <div className="w-full  py-1">
      <div className="input-label mx-2 text-custom-blue font-light text-[12px]">
        {label}
      </div>
      <div style={wrapperStyle}>
        {icon && (
          <div
            style={{
              position: "absolute",
              right: "50px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          >
            {icon}
          </div>
        )}
        <Input
          name={name}
          value={value}
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          style={inputStyle}
          addonAfter={addonAfter}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};
